import { render, staticRenderFns } from "./ApprovedAdminModal.vue?vue&type=template&id=7644dc0e&scoped=true"
import script from "./ApprovedAdminModal.vue?vue&type=script&lang=js"
export * from "./ApprovedAdminModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovedAdminModal.vue?vue&type=style&index=0&id=7644dc0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7644dc0e",
  null
  
)

export default component.exports